module.exports = __webpack_public_path__ + "img/lv1_2_1.45494b0d.png";